<h1 mat-dialog-title>{{ "forms.dataExtraction.cpChoice" | translate }}</h1>
<div mat-dialog-content style="display: flex; justify-content: center">
  <mat-form-field style="width: 100%">
    <mat-select [(ngModel)]="selectedCareplan">
      <mat-option *ngFor="let careplan of data.careplans" [value]="careplan">
        {{ careplan.description }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions style="float: right">
  <button mat-button [mat-dialog-close]="selectedCareplan" cdkFocusInitial>{{ "btn.validate" | translate }}</button>
</div>
